import type { FunctionalComponent as FC } from 'preact';

import { Icon28InfoCircle } from '@vkontakte/icons';
import { Button, Separator, SimpleCell } from '@vkontakte/vkui';

import { useWidget } from '../../context/WidgetContext';
import { EditorLockType } from '../../types/editor';
import { getIntlLocale } from '../../utils';

import styles from './styles.module.css';

interface Props {
  type: EditorLockType;
  onStartNewDialog?: () => void;
  date?: string;
}

export const WidgetLock: FC<Props> = ({ type, date, onStartNewDialog }) => {
  const { localeMessages, locale } = useWidget();
  const hasNoIcon = type === EditorLockType.Ban;

  // Собираем строчку с датой и временем, после которого произойдёт разбан
  const getBanDate = () => {
    if (!date) {
      return;
    }

    const dateObject = new Date(date);
    const intlLocale = getIntlLocale(locale);

    // Собираем дату
    const dateAndMonth = dateObject.toLocaleDateString(intlLocale, {
      day: 'numeric',
      month: 'long',
    });

    // Собираем время
    const time = dateObject.toLocaleTimeString(intlLocale, {
      hour: '2-digit',
      minute: '2-digit',
    });

    return `${dateAndMonth} ${localeMessages.lock.afterTime} ${time}`;
  };

  const WidgetLockBan = (
    <div className={styles.widgetLockBan}>
      {localeMessages.lock.banIntro} {date ? `${localeMessages.lock.banCanWritePrefix} ${getBanDate()}` : null}
    </div>
  );

  const WidgetLockClose = (
    <>
      <span>{localeMessages.lock.chatClosed} </span>
      <Button className={styles.widgetLockLink} onClick={onStartNewDialog} mode="link">
        {localeMessages.lock.newDialog}
      </Button>
    </>
  );

  const subtitle = {
    [EditorLockType.Limit]: localeMessages.lock.limit,
    [EditorLockType.Ban]: WidgetLockBan,
    [EditorLockType.Closed]: WidgetLockClose,
    [EditorLockType.Unavailable]: localeMessages.lock.unavailable,
  }[type];

  return (
    <>
      <Separator className={styles.widgetPanelSeparator} size={4} />
      <SimpleCell
        className={styles.lock}
        subtitle={subtitle}
        multiline={hasNoIcon}
        before={!hasNoIcon ? <Icon28InfoCircle className={styles.icon} width={20} height={20} /> : null}
      ></SimpleCell>
    </>
  );
};
